import type { CarbonArea } from "@/mocks/carbono";
import CarbonStatusBadge from "./CarbonStatusBadge";

interface CarbonAreaCardProps {
  area: CarbonArea;
}

export default function CarbonAreaCard({ area }: CarbonAreaCardProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-5 hover:-translate-y-1 hover:border-primary-300/70 transition-all duration-300">
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="text-sm font-semibold text-foreground-900 leading-tight">{area.name}</h3>
          <div className="text-[11px] text-foreground-500 mt-0.5">{area.type} — {area.municipality}</div>
        </div>
        <CarbonStatusBadge status={area.status} type="area" />
      </div>

      <div className="grid grid-cols-2 gap-y-2 gap-x-3 mb-3">
        <div>
          <div className="text-[11px] text-foreground-400">Área</div>
          <div className="text-xs font-medium text-foreground-700">{area.areaHa} ha</div>
        </div>
        <div>
          <div className="text-[11px] text-foreground-400">Árvores</div>
          <div className="text-xs font-medium text-foreground-700">{area.treesCount.toLocaleString("pt-BR")}</div>
        </div>
        <div>
          <div className="text-[11px] text-foreground-400">CO2e</div>
          <div className="text-xs font-medium text-primary-700">{area.co2eEstimated.toLocaleString("pt-BR", { maximumFractionDigits: 1 })} t</div>
        </div>
        <div>
          <div className="text-[11px] text-foreground-400">Risco crítico</div>
          <div className="text-xs font-medium text-danger-700">{area.criticalRiskCount}</div>
        </div>
      </div>

      <div className="flex items-center justify-between border-t border-background-100 pt-3">
        <div className="text-xs text-foreground-500">
          Confiança <span className="font-semibold text-foreground-700">{area.confidenceLevel}%</span>
        </div>
        <div className="flex gap-2">
          <button className="px-2.5 py-1 text-[11px] font-medium text-primary-700 bg-primary-50 rounded-md hover:bg-primary-100 transition-colors whitespace-nowrap">
            Detalhe
          </button>
          <button className="px-2.5 py-1 text-[11px] font-medium text-accent-700 bg-accent-50 rounded-md hover:bg-accent-100 transition-colors whitespace-nowrap">
            Mapa
          </button>
          <button className="px-2.5 py-1 text-[11px] font-medium text-foreground-600 bg-background-50 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap">
            Relatório
          </button>
        </div>
      </div>
    </div>
  );
}